import { noop } from './util';

export default ({ account, optionality, option, log, serviceFactory }) => {

  const subs = [];
  var accountUnsub;
  var last;

  return serviceFactory({
    name: "holdings-service",
    subscribe: (update) => {

      log.handle('holdings-service setup', async () => {
        accountUnsub = account.subscribe(async acct => {
          if (acct.account !== last) {
            last = acct.account;
            const opty = await optionality.deployed();
            var value = {};
            update({ value });
            subs.forEach(fn => fn());
            subs.length = 0;
            const w = opty.OptionHolder({ holder: acct.account }, { fromBlock: 0 }).watch((err, event) => {
              if (err) {
                log.error(err)
              } else {
                subs.push(option(event.args.option).subscribe(v => {
                  if (v._refreshing === false) {
                    value[event.args.option] = v;
                    update({ value });
                  }
                }))
              }
            })
            subs.push(() => w.stopWatching(noop))
          }
        })
      })
      return () => {
        accountUnsub();
        subs.forEach(fn => fn());
        subs.length = 0;
        last = null;
      }
    }
  })
}


// WEBPACK FOOTER //
// ./src/api/holdings-service.js